import React, { Component } from 'react';
import { connect } from 'react-redux';
import Clipboard from 'react-clipboard.js';
import moment from 'moment';
import Select from 'react-select';
import { SimpleFetch, SimpleFetchResponse, envConfig } from '../../../_helpers';
import { Loader } from '../../../_components';

class DomainBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domains: JSON.parse(sessionStorage.getItem('cellit_domains')),
      scriptUrl: '',
      verificating: false,
      active: this.props.status,
      domain_root: this.props.domain_root,
      isCopying: false,
      geroVersion: props.gero_version,
      cnswVersion: props.cn_sw_version,
      geroVersions: props.geroVersions,
      cnswVersions: props.cnswVersions,
      loading: {cnsw: false, gero: false}
    }

    this.handleAction = this.handleAction.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
  }

  componentDidMount() {
    this.verifyIfDomainRootExists();
  }

  verifyIfDomainRootExists() {
    let _ = this.props;
    if ( _.domain_root ) return;

    let domain = _.domain.split('/')[2];
    if ( domain.indexOf('www') !== -1 ) domain = domain.substr(4, domain.length);
    
    this.setState({domain_root: domain});
  }

  handleAction(e) {
    let attr = e.target.getAttribute('data-action');
    let domain = e.target.getAttribute('data-domain-uuid');

    let literalObject = {
      "enable": (d) => { return this.enableDomain(d) },
      "validate": (d) => { return this.validateDomain(d) },
      "edit": (d) => { return this.editDomain(d) },
      "disable": (d) => { return this.disableDomain(d) }
    }

    return literalObject[attr](domain);
  }

  async enableDomain(domain_uuid) {
    let obj = {
      "domain": {
          "status": "Active"
      }
    }
  
    let req = await SimpleFetch('PUT', {}, obj, 'main', `domain/update/${domain_uuid}`);
    let res = await SimpleFetchResponse(req, 'Ocorreu um erro ao ativar seu domínio. Tente novamente mais tarde.', 'Domínio ativado com sucesso!');

    if ( res ) return this.setState({active: "Active"});
  }

  async validateDomain(domain_uuid) {
    let req = await SimpleFetch('GET', {}, '', 'check_gero', `check-gero-script/${domain_uuid}`);
    let res = await SimpleFetchResponse(req, 'Ocorreu um erro ao validar seu domínio. Insira o script na página principal e tente novamente.', 'Script encontrado e domínio validado com sucesso!');

    if ( res ) return this.setState({validated: true});
  }

  async editDomain(domain_uuid) {
    return;
  }

  async disableDomain(domain_uuid) {
    let req = await SimpleFetch('DELETE', {}, '', 'main', `domain/remove/${domain_uuid}`);
    let res = await SimpleFetchResponse(req, 'Ocorreu um erro ao desativar seu domínio. Tente novamente mais tarde.', 'Domínio desativado com sucesso!');

    if ( res ) return this.setState({active: "Inactive"});
  }

  async handleVersionChange({value}, type) {
    this.setState({loading: {[type]: true}});

    let req = await SimpleFetch('PUT', {}, {}, 'main', `${type}/domain/${this.props.uuid}/version/${value}`);
    if ( req.status !== 200 )
      return SimpleFetchResponse(req, `Não foi possível alterar a versão do ${type}. Tente novamente mais tarde.`, "");

    this.setState({geroVersion: value, loading: {[type]: false}});
  }

  render() {
    const handleCopy = () => {
      if ( this.state.isCopying ) return;

      this.setState({isCopying: true});
      setTimeout(() => {
        this.setState({isCopying: false});
      }, 3000);
    }

    return (
      <tr className="domain-information">
        <td>{this.props.count}</td>
        <td>{this.props.name}</td>
        <td>
          <a href={this.props.domain} rel="noopener noreferrer" target="_blank">{this.props.domain}</a>
        </td>
        <td>
          { this.state.active === "Inactive" || !this.state.active ? 'Inativo' : null } 
          { this.props.gero_validate && this.state.active === "Active" ? 'Ativo' : null }
          { !this.props.gero_validate && this.state.active === "Active" ? 'Não verificado' : null }
        </td>
        <td>
          {
            !this.state.loading.gero ?
              <Select
                options={this.state.geroVersions}
                className="basic-select"
                classNamePrefix="select"
                placeholder="Selecione o filtro"
                onChange={(e) => {this.handleVersionChange(e, "gero")}}
                defaultValue={{label: this.state.geroVersion, value: this.state.geroVersion}}
              />
            : <Loader className="is-blue is-small" />
          }
        </td>
        <td>
          {
            !this.state.loading.cnsw ?
              <Select
                options={this.state.cnswVersions}
                className="basic-select"
                classNamePrefix="select"
                placeholder="Selecione o filtro"
                onChange={(e) => {this.handleVersionChange(e, "cnsw")}}
                value={{label: this.state.cnswVersion, value: this.state.cnswVersion}}
              />
            : <Loader className="is-blue is-small" />
          }
        </td>
        <td>
          <Clipboard
            className={`btn btn-xsmall ${!this.state.isCopying ? 'btn-white-outlined' : 'btn-green btn-green-white'}`}
            data-clipboard-text={`
<script type="text/javascript">
  var gls = document.createElement("script");
  gls.src = "https://personidkbr.com/static/files/gero_loader.min.js";
  gls.onload = function () {
    GeroLoader.init({
      domain: ".${this.state.domain_root}",
      gero_id: "${this.props.gero_id}"
    })
  };
	document.head.appendChild(gls);	
</script>`}
            onSuccess={() => {handleCopy()}}
          >
            {
              !this.state.isCopying ?
                <><i className="linearicons-copy"></i> Copiar script</>
              : <><i className="linearicons-file-check"></i> Copiado!</>
            }
          </Clipboard>
        </td>
        <td>
          {
            this.state.active === "Active" ?
              <>
                {
                  !this.props.gero_validate ?
                    <button className="btn btn-green btn-icon" data-action="validate" style={{marginLeft: "0"}} data-domain-uuid={this.props.uuid} title="Validar" onClick={this.handleAction}>
                      <i className="linearicons-check"></i>
                    </button>
                  : null
                }
                <button className="btn btn-red btn-icon" data-action="disable" style={{marginLeft: "0"}} data-domain-uuid={this.props.uuid} title="Desabilitar" onClick={this.handleAction}>
                  <i className="linearicons-trash2"></i>
                </button>
              </>
            : <button className="btn btn-green btn-icon" data-action="enable" style={{marginLeft: "0"}} data-domain-uuid={this.props.uuid} title="Habilitar" onClick={this.handleAction}>
                <i className="linearicons-play-circle"></i>
              </button>
          }
        </td>
      </tr>
    )
  }
}

function mapStateToProps(state) {
  const { domains } = state.listDomainsReducer;
  return domains;
}

const ConnectedDomainBlockComponent = connect(mapStateToProps)(DomainBlock);
export { ConnectedDomainBlockComponent as DomainBlockComponent };
